import { connect } from 'react-redux';
import RegionAssignment from './RegionAssignment';
import { getStates, getCountiesByState, assignFieldRepManagerToStates, assignFieldRepManagerToCounties } from 'actions/region';
import * as employeeRoles from 'typeConstants/employeeRoles';

const mapStateToProps = (state) => {
  return {
    states: state.region.states,
    counties: state.region.countiesByState,
    isFetchingStates: state.region.isFetchingStates,
    isFetchingCounties: state.region.isFetchingCountiesByState,
    cardTitle: "Assign Field Manager Region", 
    employeeRoles: [employeeRoles.FIELD_OPERATIONS_MANAGER, employeeRoles.FIELD_OPERATIONS_DIRECTOR, employeeRoles.FIELD_OPERATIONS_AVP],
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStates() {
    dispatch(getStates());
  },
  getCountiesByState(states) {
    dispatch(getCountiesByState(states));
  },
  assignStates(request) {
    dispatch(assignFieldRepManagerToStates(request));
  },
  assignCounties(request) {
    dispatch(assignFieldRepManagerToCounties(request));
  },
});


export default connect(mapStateToProps, mapDispatchToProps)(RegionAssignment);